import React from "react";

import { getIconUrl } from "../../../../../../services/asset";
import styles from "./valueOnly.scss";
import { StaticHTML } from "../../../../../../components";

const ValueOnly = ({ itemData }) => (
  <div className={styles.wrapper}>
    <div className={styles.groupName}>{itemData.group}</div>
    {itemData.data.map((data: any, i: any) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        className={`${styles.text}`}
      >
        <img alt={data} src={getIconUrl("section-check.svg")} />
        {<StaticHTML content={data} />}
      </div>
    ))}
  </div>
);

export default ValueOnly;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/ValueOnly/index.tsx